import { ElementProperties, Div, VNumber, VArray } from 'alkali'
import { CollapsibleSection } from './CollapsibleSection'

import './Accordion.less'

export interface AccordionOpts extends ElementProperties<Accordion> {
	open?: typeof VNumber
	header?: any
	items?: VArray<any>
	footer?: any
}

export default class Accordion extends Div('.accordion') {
	protected items: VArray<any>
	protected open: typeof VNumber
	created(props: AccordionOpts) {
		const open = props.open || (props.open = new VNumber(0))
		const items = props.items ? props.items.as(VArray) : new VArray([])
		props.content = items.to(_items => [
			props.header,
			_items.map((item, i) =>
				new CollapsibleSection({
					...item,
					open: open.to(i => _items.indexOf(item) == i, (open, v) => {
						v.put(open ? _items.indexOf(item): (i != 0 ? 0 : -1))
					}),
					toggleable: items.length.to(l => l > 0),
					removable: item.removable ?? items.length.to(l => l > 1),
					onRemove: () => this.onRemove(item, i)
				})
			),
			props.footer
		])
	}

	protected onRemove(item, i) {

	}
}